import { Injectable } from '@angular/core';

@Injectable()
export class ScannerSettingsProvider {
  constructor() {}

  public getScannerMargins() {
    // TODO: Calculate the size of android header and footer
    return new Scandit.Margins(0, 55 + 30, 0, 194 + 70);
  }

  public createSettings(): Scandit.ScanSettings {
    const settings = new Scandit.ScanSettings();
    settings.codeRejectionEnabled = true;
    // TODO: Adjust the scanning zone for this project
    settings.activeScanningAreaPortrait = new Scandit.Rect(0.0, 0.48, 1.0, 0.04);

    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.EAN13, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.UPCA, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.EAN8, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.UPCE, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.CODE39, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.CODE128, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.ITF, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.QR, true);
    settings.setSymbologyEnabled(Scandit.Barcode.Symbology.DATA_MATRIX, true);

    return settings;
  }
}
